import { Icon, Tooltip } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import './ItemSyncStatus.css';
import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';

export type Props = {
  isMapped: boolean;
  value: string;
};

export const ItemSyncStatus = ({ isMapped, value }: Props) => {
  const { t } = useTranslation('global');
  const { accountingSoftwareName } = useAccountingSoftwareName();

  const tooltipText = t(
    isMapped
      ? 'payables.panel.customFieldMapping.mappedTooltip'
      : 'payables.panel.customFieldMapping.unmappedTooltip',
    { integrationName: accountingSoftwareName, value },
  );

  return (
    <Tooltip placement="top" content={tooltipText} triggerAsChild>
      <Icon
        size="s"
        className={isMapped ? '' : 'unmapped'}
        name={isMapped ? 'link' : 'triangle-warning'}
      />
    </Tooltip>
  );
};
